import { useNavigate } from 'react-router-dom';
import { Settings } from "lucide-react";

import UserProfilePicture from 'components/User/UserProfilePicture'
import ContentFrame from 'components/Frame/ContentFrame';

export default function KinesisProfileHeaderV5({ 
    propProfileType = 'individual', 
    urlGroupId = null,
    urlAthleteId = null,
    kinesisProfileDetails = null,
    displaySettingsButton = true
}) {
    const navigate = useNavigate()

    let groupName = ''
    let groupDescription = ''
    let firstName = ''
    let lastName = ''
    let email = ''

    if (propProfileType === 'group') {
        groupName = kinesisProfileDetails?.name ?? 'Unknown'
        groupDescription = kinesisProfileDetails?.description ?? 'No description'
    }

    if (propProfileType === 'individual') {
        firstName = kinesisProfileDetails?.firstName ?? 'Unknown'
        lastName = kinesisProfileDetails?.lastName ?? 'Unknown'
        email = kinesisProfileDetails?.email ?? 'Unknown'
    }

    const OnSettingsButton = () => {
        if (propProfileType === 'group') {
            navigate(`/group/${urlGroupId}/settings`)
        }

        if (propProfileType === 'individual') {
            navigate(`/athlete/${urlAthleteId}/settings`)
        }
    }

    return (
        <ContentFrame>
            <div className='w-full px-3 2xl:px-4 py-4 flex items-center gap-x-2 2xl:gap-x-3'>
                {propProfileType === 'group' && (
                    <>
                        <UserProfilePicture 
                            firstName={'G'}
                            lastName={'R'}
                            shadow={false}
                        />

                        <div className='flex-1'>
                            <p className="text-sm 2xl:text-base font-semibold tracking-tight">
                                {groupName}
                            </p>

                            <p className="text-xs 2xl:text-sm text-gray-600">
                                {groupDescription.length > 0 ? groupDescription : 'No description'}
                            </p>
                        </div>
                    </>
                )}

                {propProfileType === 'individual' && (
                    <>
                        <UserProfilePicture 
                            firstName={firstName} 
                            lastName={lastName}
                            shadow={false}
                        />

                        <div className='flex-1'>
                            <p className="text-sm 2xl:text-base font-semibold tracking-tight">
                                {firstName} {lastName}
                            </p>

                            <p className="text-xs 2xl:text-sm text-gray-600">
                                {(email && email.length) > 0 ? email : 'No Email'}
                            </p>
                        </div>

                    </>
                )}

                {displaySettingsButton && (
                    <Settings 
                        className="w-6 h-6 text-gray-400 cursor-pointer" 
                        onClick={OnSettingsButton}
                    />
                )}
            </div>
        </ContentFrame>
    )
}
